export const mapLegendItems = [
    { text: 'Lot Construction Started', icon: 'dhicon-lot-construction-started-1', color: 'text-[#FFFF7F]' },
    { text: 'Final Stabilization*', icon: 'dhicon-final-stabilization-place', color: 'text-[#7FFF7F]' },
    { text: 'Temporary Stabilization', icon: 'dhicon-temporary-stabilization', color: 'text-[#FFF25D]' },
    { text: 'Construction Entrance BMP', icon: 'dhicon-construction-entrance-bmp', color: 'text-[#FFBB40]' },

    { text: 'Geotextile', icon: 'dhicon-geotextile', color: 'text-[#AEFF31]' },
    { text: 'Mulch', icon: 'dhicon-mulch', color: 'text-[#8F4B1B]' },
    { text: 'Rip Rap', icon: 'dhicon-rip-rap', color: '' },
    { text: 'Hydroseed', icon: 'dhicon-hydroseed', color: 'text-[#0101FF]' },

    { text: 'Lot Access BMP', icon: 'dhicon-lot-access-bmp', color: 'text-[#8D97A4]' },
    { text: 'Erosion Control Blanket', icon: 'dhicon-erosion-control-blanket', color: 'text-[#FF3434]' },
    { text: 'Seed & Crimp Mulch', icon: 'dhicon-seed-and-crimp-mulch', color: 'text-[#33FFFF]' },
    { text: 'Surface Roughening', icon: 'dhicon-surface-roughening', color: 'text-[#C7C689]' },

    { text: 'Seeded', icon: 'dhicon-seeded', color: 'text-[#66BB6A]' },
    { text: 'Disturbed Soil', icon: 'dhicon-disturbed-soil', color: 'text-[#CEB19D]' },
    { text: '', icon: '', color: '' },
    { text: '', icon: '', color: '' },

    { text: 'Line of Construction', icon: 'dhicon-limits-of-construction', color: 'text-[#3C9D9D]' },
    { text: 'Heavyweight Wattle', icon: 'dhicon-heavyweight-wattle', color: 'text-[#3C9D9D]' },
    { text: 'Diversion Ditch', icon: 'dhicon-diversion-ditch', color: 'text-[#A4FF69]' },
    { text: 'Straw Wattle', icon: 'dhicon-star-wattle-bio-sock', color: 'text-[#0D0DFF]' },

    { text: 'Curb Cutback', icon: 'dhicon-curb-cutback', color: 'text-[#FF1593]' },
    { text: 'Rock/Earth/Mulch Berm', icon: 'dhicon-rock-earth-mulch-berm', color: 'text-[#800180]' },
    { text: 'Slit Fence', icon: 'dhicon-silt-fence', color: 'text-[#FF0000]' },
    { text: 'Wire-Backed Slit Fence', icon: 'dhicon-wirebacked-slit-fence', color: 'text-[#FF0000]' },

    { text: 'Construction Fence', icon: 'dhicon-construction-fence', color: 'text-[#FF8634]' },
    { text: 'Perimeter Wall', icon: 'dhicon-perimeter-wall', color: '' },
    { text: 'Lot BMP', icon: 'dhicon-lot-bmp', color: 'text-[#FFA708]' },
    { text: 'Turbidity Curtain', icon: 'dhicon-turbidity-curtain', color: 'text-[#66E6D9]' },

    { text: 'Spill Kit', icon: 'dhicon-spill-kit', color: '' },
    { text: 'Construction Staging Area', icon: 'dhicon-construction-staging-area', color: '' },
    { text: 'Outfall Location', icon: 'dhicon-outfall-location', color: '' },
    { text: 'Mixing Station', icon: 'dhicon-mixing-station', color: '' },

    { text: 'Water Source', icon: 'dhicon-water-source', color: '' },
    { text: 'Concrete Wash Out', icon: 'dhicon-concrete-wash-out', color: '' },
    { text: 'Project Info Sign', icon: 'dhicon-project-information-sign', color: '' },
    { text: 'Dust Control', icon: 'dhicon-dust-control', color: '' },

    { text: 'Above Ground Storage Tank', icon: 'dhicon-above-ground-storage-tank', color: '' },
    { text: 'Storage Area', icon: 'dhicon-storage-area-containers', color: '' },
    { text: 'Turbidity Barrier', icon: 'dhicon-floating-turbidity-barrier', color: '' },
    { text: 'Sediment Basin', icon: 'dhicon-sediment-basin-trap', color: '' },

    { text: 'Stockpile', icon: 'dhicon-stockpile', color: '' },
    { text: 'Portable Toilet', icon: 'dhicon-portable-toilet', color: '' },
    { text: 'Trash Container', icon: 'dhicon-trash-container', color: '' },
    { text: 'Dewatering', icon: 'dhicon-dewatering', color: '' },

    { text: 'Removed', icon: 'dhicon-item-removed', color: '' },
    { text: 'SWPPP', icon: 'dhicon-swppp', color: '' },
    { text: 'Inlet Protection', icon: 'dhicon-inlet-protection', color: 'text-[#0000FF]' },
    { text: 'Rock Sock & Curb Check', icon: 'dhicon-rock-sock-and-curb-check', color: 'text-[#B75454]' },

    { text: 'Lot Removed/Sold', icon: 'dhicon-lot-removed-or-sold', color: 'text-[#FF0000]' },
    { text: 'North Arrow', icon: 'dhicon-north-arrow', color: '' },
    { text: 'Stormwater Management Facility', icon: 'dhicon-stormwater-management-facility', color: '' },
    { text: 'Check Dam', icon: 'dhicon-check-dam', color: '' },

    { text: 'Temporary Outlet Protection', icon: 'dhicon-temporary-outlet-protection', color: 'text-[#BDDFEB]' },
    { text: 'Receiving Waters', icon: 'dhicon-recieving-waters', color: '' },
    { text: 'Surface Water', icon: 'dhicon-surface-water', color: '' },
    { text: 'Wetland', icon: 'dhicon-wetland', color: '' },

    { text: 'Sinkhole/Spring', icon: 'dhicon-sinkhole-spring', color: '' },
    { text: 'Drywell', icon: 'dhicon-drywell', color: '' },
    { text: 'Direction of Flow', icon: 'dhicon-direction-of-flow', color: '' },
];

export const lotAccessLegendItems = [
    { text: 'Wattle', icon: 'dhicon-wattle', color: '' },
    { text: 'Curlex', icon: 'dhicon-curlex', color: '' },
    { text: 'Cut Back', icon: 'dhicon-cut-back', color: '' },
    { text: 'Rock Pad', icon: 'dhicon-rock-pad', color: '' },
    { text: 'Mulch', icon: 'dhicon-mulch-place', color: '' },
    { text: 'Trackout Control Device', icon: '', color: '', textClassName: 'trackoutControlDevice' },
];
